import { apiAthenas } from '@/services/api/apiAthenas'

export async function growLineDelivery({ demandId }: { demandId: string }) {
  return await apiAthenas.post(`delivery/${demandId}/growlines`)
}
